/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetContractsPublicBidsContractId200Ok
 */
export interface GetContractsPublicBidsContractId200Ok {
    /**
     * The amount bid, in ISK
     * @type {number}
     * @memberof GetContractsPublicBidsContractId200Ok
     */
    amount: number;
    /**
     * Unique ID for the bid
     * @type {number}
     * @memberof GetContractsPublicBidsContractId200Ok
     */
    bidId: number;
    /**
     * Datetime when the bid was placed
     * @type {Date}
     * @memberof GetContractsPublicBidsContractId200Ok
     */
    dateBid: Date;
}

/**
 * Check if a given object implements the GetContractsPublicBidsContractId200Ok interface.
 */
export function instanceOfGetContractsPublicBidsContractId200Ok(value: object): value is GetContractsPublicBidsContractId200Ok {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('bidId' in value) || value['bidId'] === undefined) return false;
    if (!('dateBid' in value) || value['dateBid'] === undefined) return false;
    return true;
}

export function GetContractsPublicBidsContractId200OkFromJSON(json: any): GetContractsPublicBidsContractId200Ok {
    return GetContractsPublicBidsContractId200OkFromJSONTyped(json, false);
}

export function GetContractsPublicBidsContractId200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractsPublicBidsContractId200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'bidId': json['bid_id'],
        'dateBid': (new Date(json['date_bid'])),
    };
}

export function GetContractsPublicBidsContractId200OkToJSON(json: any): GetContractsPublicBidsContractId200Ok {
    return GetContractsPublicBidsContractId200OkToJSONTyped(json, false);
}

export function GetContractsPublicBidsContractId200OkToJSONTyped(value?: GetContractsPublicBidsContractId200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'bid_id': value['bidId'],
        'date_bid': ((value['dateBid']).toISOString()),
    };
}

